import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ToastService } from 'src/app/services/toast/toast.service';
import { BusContactsBLL } from '../bus-contacts.bll';
import { AuthService } from 'src/app/services/auth/auth.service';
import { skipWhile, take } from 'rxjs/operators';
import { createMask } from '@ngneat/input-mask';

@Component({
  selector: 'app-bus-contact-modal',
  templateUrl: './bus-contact-modal.component.html',
})
export class BusContactModalComponent implements OnInit {

groupForm: FormGroup;
  isLoading$: Observable<boolean>;
  updateGroupLoading$: Observable<boolean>;
  isAddContactModelOpen$: Observable<boolean>;

  addGroupModal: boolean = false;

  updateContactModal: boolean = false;

  user: AuthState;
  selectedContact: any;

  contactInputMask = createMask<string>({  
    inputType: 'number',
    mask: '(999)999-9999',
    placeholder: '(xxx)xxx-xxxx',
    positionCaretOnClick: 'select'
  });

  selected_account = localStorage.getItem('selected_account') ? localStorage.getItem('selected_account') : '1';
  ad_admin_id = localStorage.getItem('ad_admin_id');


  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private bll: BusContactsBLL,
    private auth: AuthService
  ) {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required]],
      school: ['', [Validators.required]],
      number: ['', [Validators.required]],
      email: ['', [Validators.required]]

    });
  }

  ngOnInit() {
    this.bll.selectedContact$.subscribe(Contact => {
      if (Contact) {
        this.selectedContact = Contact
        this.name?.setValue(Contact.name ?? '');
        this.school?.setValue(Contact.school ?? '');
        this.number?.setValue(Contact.number ?? '');
        this.email?.setValue(Contact.email ?? '');
      }
    })
    this.bll.isUpdateContactModelOpen$.subscribe(isUpdate => {
      this.updateContactModal = isUpdate;
    })

    this.isAddContactModelOpen$ = this.bll.isAddContactModelOpen$;
    this.auth.auth$.pipe(skipWhile((val) => !val.token), take(1))
      .subscribe((val) => {
        this.user = val;
        if (this.user.id) {
          this.initObservables();
        }
      });
  }

  initObservables() {
    this.isLoading$ = this.bll.isLoading$;
  }

  resetModalState() {
    this.groupForm.reset();
  }

  updateContact() {
    this.bll.editContact(
      this.selectedContact.id, this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id: null
    );
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
    this.bll.toggleAddContactModel(false);
  }

  createContact() {
    this.bll.createContact(
      this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id: null
    );
    this.resetModalState()
    this.bll.toggleAddContactModel(false);
  }

  closeModel(isOpen: boolean) {
    this.bll.toggleAddContactModel(isOpen);
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
  }

  //#region FORM GETTERS

  get name() {
    return this.groupForm.get('name');
  }

  get school() {
    return this.groupForm.get('school');
  }

  get number() {
    return this.groupForm.get('number');
  }

  get email() {
    return this.groupForm.get('email');
  }

  //#endregion FORM GETTERS

}
